module.exports = __webpack_public_path__ + "img/Brown surgeonfish.d6b4b459.png";